module.exports = "static/assets/c216c70ef78cc80a1538a3accc6612af.svg";